import axios from 'axios'
import axiosplugin from './axios'

const CancelToken = axios.CancelToken;
let source = CancelToken.source();
const options = {
  responseType: 'text',
  timeout: 30000, 
  cancelToken: source.token
}

export default {
  cancelCall(){
    source.cancel('Operation canceled.');
    source = CancelToken.source();
  },  
  getDocumentTypes(){
    return new Promise(function (resolve,reject) {
      axiosplugin.get( process.env.VUE_APP_CF_AUTH_URL + "/account/documentTypes",
      //{params}, 
       options).then((response) => {
        resolve(response)
      }).catch((e)=>{
          console.log("error: ",e)
          reject(e)
      })
    })
  },  
  getUsers(){
    return new Promise(function (resolve,reject) {
      axiosplugin.get( process.env.VUE_APP_CF_AUTH_URL + "/api/v1/users",
      //{params}, 
      options).then((response) => {
        resolve(response)
      }).catch((e)=>{
          console.log("error: ",e)
          reject(e)
      })
    })
  },
  getUser(id){
    return new Promise(function (resolve,reject) {
      axiosplugin.get(process.env.VUE_APP_CF_AUTH_URL + "/api/v1/users/"+id,
      options).then((response) => {
        resolve(response)
      }).catch((e)=>{
          console.log("error: ",e)
          reject(e)
      })
    })
  },
  updateUser(user){
    return new Promise(function (resolve,reject){
      axiosplugin.patch( process.env.VUE_APP_CF_AUTH_URL + '/api/v1/users', user ,options).then((response) => {
        resolve(response)
      }).catch((e)=>{
        console.log("error: ",e)
        reject(e)
      })
    }) 
  },
  deleteUser(userId){
    return new Promise(function (resolve,reject){
      axiosplugin.delete( process.env.VUE_APP_CF_AUTH_URL + '/api/v1/users/'+userId ,options).then((response) => {
        resolve(response)
      }).catch((e)=>{
        console.log("error: ",e)
        reject(e)
      })
    }) 
  }
}